<template>
    <section class="install__to__schedule fill-height fill-width">
        <v-container :fluid="$vuetify.breakpoint.mdAndUp" :class="$vuetify.breakpoint.mdAndDown ? 'mb-0' : ''" >
            <v-row no-gutters class="logo">
                <v-col flat absolute class="pt-14 pb-10 d-flex">
                    <v-img src="/logo_blanc.png" contain max-width="162" ></v-img>
                </v-col>
            </v-row>
            <v-row >
                <v-col lg="6" cols="12">
                    <v-row>
                        <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="2"></v-col>
                        <v-col :cols="$vuetify.breakpoint.lgAndUp ? 9:12">
                            <v-container :fluid="true" :class="{'pl-5':$vuetify.breakpoint.mdAndDown}">
                                <div class="cards_steps">
                                    <h1 class="steps__title">Primeros pasos</h1>
                                    <div v-for="card in steps" :class="$vuetify.breakpoint.smAndUp ? 'pr-16 my-4' : 'my-8'">
                                        <card-schedule-installation 
                                            :step="card.id"
                                            :icon="card.icon"
                                            :title="card.title"
                                            :content="card.content"
                                        >
                                        </card-schedule-installation>
                                    </div>                                                
                                </div>
                            </v-container>
                        </v-col>
                        <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp" ></v-col>
                    </v-row>
                </v-col>
                <v-col lg="6" cols="12">
                    <v-row>
                        <v-col v-if="$vuetify.breakpoint.smAndUp" cols="2"></v-col>
                        <v-col v-if="$vuetify.breakpoint.xs" cols="1"></v-col>
                        <v-col cols="3" class="pt-8">
                            <img src="/webinar-photo.png" width="150"/>
                        </v-col>
                        <v-col cols="6" class="pt-14 right__card">
                            <h1>Agenda una llamada para instalar tu conector</h1>
                            <p class="pt-6" >Gemma Alonso</p>
                            <p>Directora Comercial</p>
                        </v-col>
                    </v-row>
                </v-col>
                
            </v-row>
        </v-container>
    </section>
</template>

<script>
import { mapActions } from "vuex";
import CardScheduleInstallation from '@/components/CardScheduleInstallation.vue'

export default {
    name: "InstallSchedule",
    components: {
        CardScheduleInstallation,
    },
    
    data() {
        return {
            steps: [
                {
                    id: 1,
                    icon: 'mdi-calendar-check-outline',
                    title: 'Instalación del contenedor',
                    content: 'Coordinamos una llamada para poder instalar el conector y vincular tu sistema contable con Inmatic.'
                },
                {
                    id: 2,
                    icon: 'mdi-school-outline',
                    title: 'Acceso a la formación',
                    content: 'Agendamos una sesión para enseñarte cómo aprovechar al máximo la herramienta de Inmatic.'
                },
                {
                    id: 3,
                    icon: 'mdi-monitor-dashboard',
                    title: 'Contabilidad automatizada',
                    content: 'A partir de la formación comenzará tu período de prueba gratuito durante 7 días. Podrás registrar hasta 100 facturas.'
                }
            ]
        }
    },
    mounted() {
        this.changeCrispColor("light_blue");
    },
    methods: {
        ...mapActions({
        changeCrispColor: "changeCrispColor"
        }),
    }
    
};
</script>

<style scoped>
.install__to__schedule {
    background-image: url('/inmatic_bg_nohand.jpg');
    background-position: center;
    background-size: cover;
    min-height: 100vh;
    display: flex;
    justify-content: flex-end;
    color: white;
    font-family: 'Roboto', sans-serif !important;
}

.logo{
    padding: 0px 60px 0px 60px !important;
}
.steps__title {
    font-size: 45px;
    font-weight: 600;
    line-height: 50px;
    padding-bottom: 20px;
}
.cards_steps > :not(div:first-of-type) div {
    background-color: transparent !important;
    color: white !important;
    border: 0.50px #F2F1FF solid !important;
}
.right__card h1{
    font-size: 26px;
    font-weight: 500;
    line-height: 20px;
    word-wrap: break-word;
}
.right__card > p:first-of-type {
    font-size: 18px;
    font-weight: 700;
    line-height: 15px;
    word-wrap: break-word;
    margin-bottom: 2px;
}
.right__card > p:last-of-type {
    font-weight: 300;
    line-height: 15px;
    word-wrap: break-word;
}
@media screen and (max-width: 600px) {
    .logo{
        padding: 0px 10px 0px 10px !important;
    }
    .right__card {
        padding-left: 40px;
    }
}
</style>
